import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const WhyUsSection = () => {
  const { t } = useTranslation('home');

  const reasons = [
    {
      icon: 'ri-time-line',
      title: t('whyUs.reason1.title'),
      description: t('whyUs.reason1.desc'),
      shortDesc: t('whyUs.reason1.desc'),
    },
    {
      icon: 'ri-store-3-line',
      title: t('whyUs.reason2.title'),
      description: t('whyUs.reason2.desc'),
      shortDesc: t('whyUs.reason2.desc'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('whyUs.reason3.title'),
      description: t('whyUs.reason3.desc'),
      shortDesc: t('whyUs.reason3.desc'),
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('whyUs.reason4.title'),
      description: t('whyUs.reason4.desc'),
      shortDesc: t('whyUs.reason4.desc'),
    },
    {
      icon: 'ri-line-chart-line',
      title: t('whyUs.reason5.title'),
      description: t('whyUs.reason5.desc'),
      shortDesc: t('whyUs.reason5.desc'),
    },
    {
      icon: 'ri-global-line',
      title: t('whyUs.reason6.title'),
      description: t('whyUs.reason6.desc'),
      shortDesc: t('whyUs.reason6.desc'),
    },
  ];

  const [expandedMobile, setExpandedMobile] = useState<number | null>(null);

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 sm:px-4 sm:py-2 bg-amber-500/10 border border-amber-500/30 rounded-full text-xs sm:text-sm text-amber-400 font-medium mb-3 sm:mb-4">
            <i className="ri-star-line mr-1.5"></i>Lợi Thế Cạnh Tranh
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-6 font-serif px-2">
            {t('whyUs.title')}
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-300 max-w-3xl mx-auto px-2">
            {t('whyUs.description')}
          </p>
        </div>

        {/* Mobile Timeline Layout */}
        <div className="sm:hidden">
          <div className="relative pl-8">
            {/* Timeline line */}
            <div className="absolute left-[15px] top-2 bottom-2 w-[2px] bg-gradient-to-b from-amber-500 via-amber-400 to-amber-500/20"></div>

            <div className="space-y-4">
              {reasons.map((reason, index) => {
                const isExpanded = expandedMobile === index;
                return (
                  <div
                    key={index}
                    className="relative cursor-pointer"
                    onClick={() => setExpandedMobile(isExpanded ? null : index)}
                  >
                    {/* Timeline dot */}
                    <div className={`absolute -left-8 top-3 w-[30px] h-[30px] flex items-center justify-center rounded-full border-2 transition-all duration-300 ${isExpanded ? 'bg-amber-500 border-amber-400 scale-110' : 'bg-gray-900 border-amber-500/40'}`}>
                      <i className={`${reason.icon} text-xs ${isExpanded ? 'text-black' : 'text-amber-400'}`}></i>
                    </div>

                    {/* Content card */}
                    <div className={`rounded-xl p-3.5 border transition-all duration-300 ${isExpanded ? 'bg-gradient-to-br from-gray-900 to-black border-amber-500/50' : 'bg-gray-900/50 border-amber-500/10'}`}>
                      <div className="flex items-center justify-between">
                        <h3 className="text-sm font-bold text-white">{reason.title}</h3>
                        <i className={`ri-arrow-down-s-line text-amber-400 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}></i>
                      </div>
                      <p className="text-gray-400 text-xs leading-relaxed mt-1.5">
                        {isExpanded ? reason.description : reason.shortDesc}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Desktop Grid Layout */}
        <div className="hidden sm:grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-gray-900 to-black rounded-2xl p-5 sm:p-6 md:p-8 border border-amber-500/20 hover:border-amber-500/50 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center bg-gradient-to-br from-amber-500 to-yellow-600 rounded-xl mb-4 sm:mb-5 md:mb-6 group-hover:scale-110 transition-transform">
                <i className={`${reason.icon} text-xl sm:text-2xl md:text-3xl text-black`}></i>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-bold text-white mb-2 sm:mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;